import { DocumentStatus } from '@synergy/models';
import { StatusFilter } from '@synergy/components';
import { useIntl } from 'react-intl';

import { STATUS_OPTIONS, StatusListKey } from './document-status-options';

/**
 * The status filter of a document list: the statuses of that kind only,
 * several at once, named like its status pill (GF 30.10.2026, #2340). The
 * sub-views of the navigation set the same filter, so what they chose stands
 * here and can be changed.
 */
export const DocumentStatusFilter = ({ list }: { list: StatusListKey }) => (
    <StatusFilter
        multiple={true}
        documentStatus={STATUS_OPTIONS[list].statuses as DocumentStatus[]}
        translationIdOf={STATUS_OPTIONS[list].translationIdOf}
    />
);

/** The statuses of a list with the names its pill gives them, for the chips (#2340). */
export const useStatusNames = (list: StatusListKey): { value: string; label: string }[] => {
    const intl = useIntl();
    const options = STATUS_OPTIONS[list];

    return options.statuses.map(status => ({
        value: status,
        label: intl.formatMessage({ id: options.translationIdOf(status) }),
    }));
};
